import React from 'react';

import propTypes from 'propTypes';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class CollectionPrice extends React.Component {
  static propTypes = {
    collection: propTypes.array.isRequired,
  };

  render() {
    const { collection } = this.props;

    const price = collection.reduce((accumulator, currentValue) => {
      return (accumulator +=
        currentValue.skuInfo.price * currentValue.quantity);
    }, 0);

    return <PriceSpan amount={price} />;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CollectionPrice.js